import React, { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import BreadcrumbsContainer from '../common/breadcurmbs/BreadcrumbsContainer';
import ApprovalDelegationTab from '../../components/attendancemng/ApprovalDelegationTab';
import ApprovalDelegationModal from '../../components/attendancemng/ApprovalDelegationModal';
import * as approvalV2Api from '../../lib/api/approvalV2';

const ApprovalDelegationContainer = () => {
  const { enqueueSnackbar } = useSnackbar();

  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedDelegation, setSelectedDelegation] = useState(null);

  const fetchList = async () => {
    setLoading(true);
    try {
      const res = await approvalV2Api.getApprovalV2Delegations();
      setList(res.data.list || []);
    } catch (e) {
      enqueueSnackbar('대결 설정 조회 실패', { variant: 'error' });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSave = async (values) => {
    try {
      if (selectedDelegation) {
        await approvalV2Api.editApprovalV2Delegation(selectedDelegation.delegationId, values);
        enqueueSnackbar('대결 설정을 수정했습니다.', { variant: 'success' });
      } else {
        await approvalV2Api.addApprovalV2Delegation(values);
        enqueueSnackbar('대결 설정을 등록했습니다.', { variant: 'success' });
      }
      setModalOpen(false);
      setSelectedDelegation(null);
      fetchList();
    } catch (e) {
      enqueueSnackbar(e?.response?.data?.message || '대결 설정 저장에 실패했습니다.', { variant: 'error' });
    }
  };

  const handleDelete = async (row) => {
    try {
      await approvalV2Api.removeApprovalV2Delegation(row.delegationId);
      enqueueSnackbar('대결 설정을 삭제했습니다.', { variant: 'success' });
      fetchList();
    } catch (e) {
      enqueueSnackbar(e?.response?.data?.message || '대결 설정 삭제에 실패했습니다.', { variant: 'error' });
    }
  };

  return (
    <>
      <BreadcrumbsContainer title="결재관리/대결 관리" />
      <ApprovalDelegationTab
        list={list}
        loading={loading}
        onAdd={() => {
          setSelectedDelegation(null);
          setModalOpen(true);
        }}
        onEdit={(row) => {
          setSelectedDelegation(row);
          setModalOpen(true);
        }}
        onDelete={handleDelete}
      />
      <ApprovalDelegationModal
        open={modalOpen}
        data={selectedDelegation}
        onClose={() => {
          setModalOpen(false);
          setSelectedDelegation(null);
        }}
        onSave={handleSave}
      />
    </>
  );
};

export default ApprovalDelegationContainer;
